export default __webpack_public_path__ + "static/media/multibanco.dbabf390.svg";